import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.1529 2.74687C6.91228 2.16564 6.27794 1.85628 5.67171 2.0219L2.92183 2.77187C2.37811 2.92186 2 3.41559 2 3.97806C2 11.709 8.26847 17.9774 15.9994 17.9774C16.5619 17.9774 17.0556 17.5993 17.2056 17.0556L17.9555 14.3057C18.1212 13.6995 17.8118 13.0652 17.2306 12.8246L14.2307 11.5746C13.7214 11.3621 13.1308 11.509 12.7839 11.9371L11.5215 13.4776C9.32155 12.4371 7.54038 10.6559 6.4998 8.45599L8.04036 7.19667C8.46847 6.84669 8.61533 6.25921 8.40284 5.74986L7.1529 2.74999V2.74687Z",
		fill: "#0D2976"
	})
});
export default SvgPhone;
